import PageTitle from '../../components/PageTitle'
import KnobsTab from './KnobsTab'

// PACE-only knobs (PRISM's iEDD knobs now live under Delivery Performance → Intelligent EDD (PRISM)).
const PACE_KNOB = (k) => k.group !== 'prism-iedd'

/**
 * PACE → Business Knobs. Global defaults or per-merchant overrides for the decision layer.
 * Split out of the old tabbed Allocation Config page. Internal/Tools only.
 */
export default function BusinessKnobsPage() {
  return (
    <div>
      <PageTitle>PACE · Business Knobs</PageTitle>
      <KnobsTab knobFilter={PACE_KNOB} tiered paymentModes />
    </div>
  )
}
